import { render, staticRenderFns } from "./superiorStaffNavBar.vue?vue&type=template&id=3618412e&scoped=true&"
import script from "./superiorStaffNavBar.vue?vue&type=script&lang=js&"
export * from "./superiorStaffNavBar.vue?vue&type=script&lang=js&"
import style0 from "./superiorStaffNavBar.vue?vue&type=style&index=0&id=3618412e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618412e",
  null
  
)

export default component.exports